export default __webpack_public_path__ + "static/media/rodzenstwo.c50df9a9.jpeg";